import { Component, effect, inject, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { UnavailableComponent } from '@shared/components';
import { NewsItemFacade } from '@app/store/news-item';
import { DeleteButtonComponent } from './delete-button/delete-button.component';

@Component({
    selector: 'app-news-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [DatePipe, TranslateModule, ButtonModule, DeleteButtonComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly newsItemFacade = inject(NewsItemFacade);

    readonly newsItem = this.newsItemFacade.newsItem;
    readonly loading = this.newsItemFacade.loading;
    readonly error = this.newsItemFacade.error;
    readonly saving = this.newsItemFacade.saving;

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.newsItemFacade.getNewsItem(id);
        }

        effect(() => {
            if (this.newsItemFacade.saved()) {
                this.close({ replaceUrl: !this.newsItemFacade.newsItem() });
            }
        });
    }

    ngOnDestroy(): void {
        this.newsItemFacade.clear();
    }

    onEdit(): void {
        const newsItem = this.newsItem();
        if (newsItem) {
            this.router.navigate([{ outlets: { modal: ['news', 'edit', newsItem.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
